import {NewMarkdownViewer} from '@github-ui/markdown-viewer/NewMarkdownViewer'
import type {SafeHTMLString} from '@github-ui/safe-html'
import {CollapsiblePanel} from './CollapsiblePanel'
import styles from './Description.module.css'

type OverviewDescriptionProps = {
  descriptionHtml: SafeHTMLString | null
}

/** PR description section on the Overview tab */
export function Description({descriptionHtml}: OverviewDescriptionProps) {
  const isEmptyDescription = !descriptionHtml || descriptionHtml === ''
  // eslint-disable-next-line @github-ui/github-monorepo/no-cast-as-safe-html-string -- static string literal is safe
  const placeholderText = 'No description provided.' as SafeHTMLString

  return (
    <CollapsiblePanel heading="Description">
      <div className={styles.body}>
        <NewMarkdownViewer
          verifiedHTML={isEmptyDescription ? placeholderText : descriptionHtml}
          className={isEmptyDescription ? 'fgColor-muted text-italic' : undefined}
        />
      </div>
    </CollapsiblePanel>
  )
}
